import React from 'react'

interface NavbarSettingIconProps {
  size?: number
  color?: string
  className?: string
  showBackground?: boolean
}

const NavbarSettingIcon: React.FC<NavbarSettingIconProps> = ({
  size = 32,
  color = 'white',
  className,
  showBackground = true,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_437_15176)">
        {/* 背景圆形 - 可选 */}
        {showBackground && (
          <rect
            width="32"
            height="32"
            rx="16"
            transform="matrix(1 0 0 -1 0 32)"
            fill="black"
            fillOpacity="0.2"
          />
        )}
        {/* 三条横线 */}
        <path
          d="M22 20.25C22.4142 20.25 22.75 20.5858 22.75 21C22.75 21.4142 22.4142 21.75 22 21.75H10C9.58579 21.75 9.25 21.4142 9.25 21C9.25 20.5858 9.58579 20.25 10 20.25H22ZM22 15.25C22.4142 15.25 22.75 15.5858 22.75 16C22.75 16.4142 22.4142 16.75 22 16.75H10C9.58579 16.75 9.25 16.4142 9.25 16C9.25 15.5858 9.58579 15.25 10 15.25H22ZM22 10.25C22.4142 10.25 22.75 10.5858 22.75 11C22.75 11.4142 22.4142 11.75 22 11.75H10C9.58579 11.75 9.25 11.4142 9.25 11C9.25 10.5858 9.58579 10.25 10 10.25H22Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_437_15176">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NavbarSettingIcon
